module.exports = __webpack_public_path__ + "media/images/big-plus-ce2f58729931c15d0e181b470bccaace.png";